import { render, staticRenderFns } from "./PostPaymentHandoverInfo.vue?vue&type=template&id=58dbafb8"
import script from "./PostPaymentHandoverInfo.vue?vue&type=script&lang=js"
export * from "./PostPaymentHandoverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports